import React, { createContext } from 'react';
import styles from './CardGrid.module.scss';
import cs from 'classnames';
export var CardSizeContext = createContext({
  layout: 'small',
  baseHeight: 0
});

/**
 * @param {Object} props React component props
 * @param {Number|String} props.baseHeight if you want expand/collapse cards, set a base
 *   height to cap a card's height
 * @param {String} props.size large|medium|small determines layout of child cards
 * @param {JSX} props.children the cards
 */
var Component = function CardGrid(_ref) {
  var _ref$baseHeight = _ref.baseHeight,
    baseHeight = _ref$baseHeight === void 0 ? 0 : _ref$baseHeight,
    size = _ref.size,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(CardSizeContext.Provider, {
    value: {
      layout: size,
      baseHeight: baseHeight
    }
  }, /*#__PURE__*/React.createElement("ul", {
    className: cs(styles.grid, styles["grid--".concat(size)])
  }, children));
};
Component.displayName = 'CardGrid';
export default Component;